import script from "./AppMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMessage.vue?vue&type=script&setup=true&lang=ts"

import "./AppMessage.vue?vue&type=style&index=0&id=098614b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-098614b6"]])

export default __exports__